/**
 * The reporting year a measurement belongs to: the UTC calendar year of the
 * reading. Aggregation, the merge overlap guards, and the wizard's summaries
 * must all bucket a series the same way, so this is the one definition.
 */
export function measurementReportingYear(measuredAtUtc: Date): number {
  return measuredAtUtc.getUTCFullYear();
}

/**
 * Storage locations claimed by two or more DIFFERENT chemicals' measurement
 * series in one facility-year. Combining such series would double-count the
 * shared location on re-aggregation, so these force a Keep or Leave blank.
 * A single chemical's own multiple locations never collide.
 */
export function findSharedMeasurementStorageLocationIds(
  storageLocationIdsByChemical: ReadonlyMap<string, ReadonlySet<string>>
): Set<string> {
  const seenChemicalByLocationId = new Map<string, string>();
  const sharedLocationIds = new Set<string>();
  for (const [chemicalId, locationIds] of storageLocationIdsByChemical) {
    for (const locationId of locationIds) {
      const seenChemicalId = seenChemicalByLocationId.get(locationId);
      if (seenChemicalId !== undefined && seenChemicalId !== chemicalId) {
        sharedLocationIds.add(locationId);
      }
      seenChemicalByLocationId.set(locationId, chemicalId);
    }
  }
  return sharedLocationIds;
}
